(function () {
      function initUpsellButtons() {
        const upsellButtons = document.querySelectorAll('[data-upsell-add-to-cart]');

        if (!upsellButtons.length) return;

        upsellButtons.forEach((button) => {
          // Check if already initialized
          if (button.dataset.initialized === 'true') return;
          button.dataset.initialized = 'true';

          button.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();

            const variantId = this.dataset.variantId;
            const originalContent = this.innerHTML;

            // Add loading state
            this.classList.add('loading');
            this.innerHTML = '⋯';
            this.disabled = true;

            // Add to cart via Shopify AJAX API
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                items: [
                  {
                    id: variantId,
                    quantity: 1,
                  },
                ],
              }),
            })
              .then((response) => response.json())
              .then((data) => {
                // Success - update cart
                this.innerHTML = '✓';

                // Refresh cart drawer for Sense theme
                fetch('/?section_id=cart-drawer')
                  .then((response) => response.text())
                  .then((html) => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newCartDrawer = doc.querySelector('cart-drawer');
                    const currentCartDrawer = document.querySelector('cart-drawer');

                    if (newCartDrawer && currentCartDrawer) {
                      currentCartDrawer.innerHTML = newCartDrawer.innerHTML;

                      // Re-initialize upsell buttons after cart refresh
                      setTimeout(() => {
                        initUpsellButtons();
                      }, 100);
                    }

                    // Update cart icon count
                    fetch('/cart.js')
                      .then((response) => response.json())
                      .then((cart) => {
                        document.querySelectorAll('[data-cart-count]').forEach((el) => {
                          el.textContent = cart.item_count;
                        });
                      });
                  });
              })
              .catch((error) => {
                console.error('Error adding to cart:', error);
                this.innerHTML = '!';
                this.classList.remove('loading');
                this.disabled = false;

                setTimeout(() => {
                  this.innerHTML = originalContent;
                }, 2000);
              });
          });
        });
      }

      // Initialize immediately
      initUpsellButtons();

      // Also initialize on DOMContentLoaded
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initUpsellButtons);
      }

      // Use MutationObserver to detect when cart drawer content changes
      const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.addedNodes.length) {
            initUpsellButtons();
          }
        });
      });

      // Observe the entire document for cart drawer updates
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    })();